import { tv, type VariantProps } from 'tailwind-variants';
export type OrDesignStudioBlockVariants = VariantProps<
  typeof orDesignStudioBlockVariants
>;

const orDesignStudioBlockVariants = tv({
  slots: {
    base: 'mx-auto md:grid md:grid-cols-12 md:grid-rows-1 md:items-center',
    mainImageContainer:
      'h-313 w-full mb-8 md:col-span-6 md:h-800 md:mb-0 [&>figure]:h-full',
    header: 'mb-8 md:mb-12',
    studioName: 'mb-3 md:mb-0.13',
  },
  variants: {
    size: {
      sm: 'text-md',
      lg: 'text-lg',
    },
    topSpacing: {
      xs: 'pt-xs',
      sm: 'pt-sm',
      md: 'pt-md',
      lg: 'pt-lg',
      xl: 'pt-xl',
    },
    bottomSpacing: {
      xs: 'pb-xs',
      sm: 'pb-sm',
      md: 'pb-md',
      lg: 'pb-lg',
      xl: 'pb-xl',
    },
  },
  compoundVariants: [],
});

export default orDesignStudioBlockVariants;
